export const UserFeatures = {
  Translation: 'translation',
  VoiceToText: 'voiceToText',
  BiometricSecurity: 'biometricSecurity',
  CustomThemes: 'customThemes',
  Broadcasting: 'broadcasting'
} as const

export type UserFeatures = typeof UserFeatures[keyof typeof UserFeatures]
